import {defineStore} from 'pinia'
import {isEmpty} from "lodash";
import Vue from "vue";

export const useRulesStore = defineStore('rules', {
    state: () => {
        return {
            rules: [],
            rulesInitialState: [],
        }
    },
    actions: {
        setRules(rules) {
            Vue.set(this, 'rules', rules);
        },
        getRules() {
            return this.rules;
        },
        getRulesInitialState() {

            if (typeof this.rulesInitialState !== 'undefined' && ! isEmpty(this.rulesInitialState)) {
                return JSON.parse(this.rulesInitialState);
            }

        },
        setRulesInitialState(rules) {

            if (typeof rules === 'object') {
                this.rulesInitialState = JSON.stringify(rules);
            }

        }
    },
    getters: {}

})
